import React, { useRef } from "react"
function IndeterminateCheckbox({ indeterminate, className = "", ...rest }) {
  const ref = useRef(null)

  // React.useEffect(() => {
  //   if (ref.current) {
  //     ref.current.checked = rest.checked // Set the checked state directly
  //     ref.current.indeterminate = indeterminate // Apply indeterminate state as well
  //   }
  // }, [indeterminate, rest.checked])

  React.useEffect(() => {
    if (typeof indeterminate === "boolean") {
      ref.current.indeterminate = !rest.checked && indeterminate
    }
  }, [ref, indeterminate])

  //console.log("IndeterminateCheckbox::", indeterminate, rest)
  return <input type="checkbox" ref={ref} className={className} {...rest} />
}

export default IndeterminateCheckbox
